seedWebControllers.controller('ScopeEditNameController', ['$scope', 'scopeItem', '$uibModalInstance', '$timeout', 'translation',
    function ($scope, scopeItem, $uibModalInstance, $timeout, translation) {
        $scope.scopeItem = scopeItem;
        $scope.translation = translation;

        console.log('ScopeEditname');
        console.log(scopeItem);

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.save = function () {
            $uibModalInstance.close($scope.scopeItem);
        };
    }]
);